import React from "react";
import { BrowserRouter } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import AppContentContainer from "pages/App/AppContentContainer";
import AppProviders from "providers/AppProviders";

import { useRefreshToken } from "hooks/useRefreshToken";

function App() {
  const { isRefreshLoading } = useRefreshToken();

  if (isRefreshLoading) {
    return null;
  }

  return (
    <BrowserRouter>
      <AppProviders>
        <CssBaseline />
        <AppContentContainer />
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
